import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { SettingModel } from 'src/app/core/models/classes/setting';
import { SettingsService } from 'src/app/core/services/settings.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-emailsettings',
  templateUrl: './emailsettings.component.html',
  styleUrls: ['./emailsettings.component.scss']
})

export class EmailsettingsComponent implements OnInit{
  server: string = '';
  port: string = '';
  email: string = '';
  testemail: string = '';
  pass: string = '';
  ssl: boolean = false;
  isTestMode: boolean = false;
  wmsLink: string = '';
  mapCacheId: string = 'd79c26749188426381c70996c0bd18ca';
  mapCacheName: string = '';
  srid: number = 0;
  attributation: string = 'OpenStreetMap® contributors';
  domainname:string='';
  appSettings: SettingModel[] = [];

  constructor(
    private settingService: SettingsService,
    private _snackBar: MatSnackBar,
    public dialogRef: MatDialogRef<EmailsettingsComponent>
  ) {}

  ngOnInit(): void {
    this.settingService.getSettings().subscribe({
      next: (s) => {
        this.server = s.server;
        this.port = s.port;
        this.email = s.email;
        this.pass = s.password;
        this.ssl = s.ssl;

        this.mapCacheId = s.mapCacheId;
        this.wmsLink = s.wmsLink;
        this.mapCacheName = s.mapCacheName;
        this.srid = s.srid;
        this.domainname = s.domainName;
        this.attributation = s.mapAttributation;
      },
      error: (err) => {
        throw Error(err.Status);
      },
    });
  }

  onSave(): void {
    var setting = new SettingModel();
    //Email settings
    setting.server = this.server;
    setting.email = this.email;
    setting.password = this.pass;
    setting.port = this.port;
    setting.ssl = this.ssl;

    //Map settings
    setting.mapCacheId = this.mapCacheId;
    setting.mapCacheName = this.mapCacheName;
    setting.srid = this.srid;
    setting.wmsLink = this.wmsLink;
    setting.mapAttributation= this.attributation;

    this.settingService.addSettings(setting).subscribe({
      next: (data) => {
        if (data.status === 200) {
          this._snackBar.open($localize `Email settings saved successfully`, '', {
            duration: 3000
          });
          this.dialogRef.close();
        }
      },
    });
  }

  checkConnection(){
    if(this.server === '' || this.port === '' || this.email === '' || this.pass === ''){
      this._snackBar.open($localize `Fields cannot be empty`, '', {
        duration: 3000
      });
    }
    else{
      this.isTestMode = !this.isTestMode;
      this.testemail = '';
    }    
  }

  sendEmail(){   
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    if(this.testemail === '')//validate field if empty
    {
      this._snackBar.open($localize `Provide a valid email address`, '', {
        duration: 3000
      });
    }
    else if(!emailRegex.test(this.testemail)){
      this._snackBar.open($localize `Invalid email address`, '', {
        duration: 3000
      });
    }
    else //valid email
    {
      this.settingService.sendTestNotification(this.testemail).subscribe({
        next:(data)=>{
          if(data.status === 200)//success
          {
            this._snackBar.open($localize `Test email sent successfully`, '', {
              duration: 3000
            });
            this.dialogRef.close();
          }
          else{
            this._snackBar.open($localize `An error occurred. Check logfile.`, '', {
              duration: 3000
            });
          }
        },
        error:(err)=>{
          this._snackBar.open($localize `An error occurred. Check logfile.`, '', {
            duration: 3000
          });
        }
      })
    }    
  }
}